<template>
    <ContentComp>
        <FormLayout :label-width="250">
            <FormLayoutRow>
                <FormLayoutLabel
                    text="stationrole.printonresultlist"
                    tooltip="stationrole.printonresultlisttooltip"
                ></FormLayoutLabel>
                <InputBool v-model="model!.PrintOnResultlist" />
            </FormLayoutRow>
            <FormLayoutRow>
                <FormLayoutLabel
                    text="stationrole.ignoreinsplitresult"
                    tooltip="stationrole.ignoreinsplitresulttooltip"
                ></FormLayoutLabel>
                <InputBool v-model="model!.IgnoreInSplitresult" />
            </FormLayoutRow>
        </FormLayout>
    </ContentComp>
</template>
<script lang="ts" setup>
import { InputBool } from '@/components';

import { FormLayout, FormLayoutLabel, FormLayoutRow } from '@/components/Form';
import ContentComp from '@/components/layout/ContentComp.vue';
import { StationRole } from '@/objects/generated';

const model = defineModel<StationRole | null>({ required: true });
</script>
